import * as React from 'react';
import { A as Account } from '../../Account-91a73b66.js';
import { A as AccountNew } from '../../AccountNew-c15de3a3.js';
import { A as AccountBut } from '../../ProfileButton-2198032b.js';
import '../../SvgIcon-f1131561.js';
import '../../_tslib-4c7d6ae2.js';
import 'styled-components';
import '../../variables-80f55df9.js';

var ProfileLoginButton = function (_a) {
    var text = _a.text, onClick = _a.onClick, newIcon = _a.newIcon;
    return (React.createElement(AccountBut, { id: "header-account-button", "data-testid": "miTiendeo_button", onClick: function () { return onClick(); }, "aria-label": "account button" },
        !newIcon && React.createElement(Account, null),
        newIcon && React.createElement(AccountNew, null),
        React.createElement("p", null,
            " ",
            text,
            " ")));
};

export { ProfileLoginButton as default };
//# sourceMappingURL=ProfileLoginButton.js.map
